import { type SearchRequest } from '@searchkit/api';

import { getTimezoneForRepub } from '~/search-domain/constants/timezones';
import { getPositiveEvSorting, resultAttributes } from '~/search-domain/pipelines/positive-ev/query-config';
import { createQueryFactory } from '~/search-domain/pipelines/positive-ev/query-factory';
import { type SearchDomainContext } from '~/search-domain/types';
import { getHitRateBucket, normalizeFacetFilters, resolveActiveSort, withRequestParams } from '~/search-domain/utils';

export function buildPositiveEvQuery(context: SearchDomainContext, searchRequest: SearchRequest) {
  const params = searchRequest.request?.params ?? {};
  const facetFilters = normalizeFacetFilters(params.facetFilters);

  const mapSearchRequest: SearchRequest = withRequestParams(searchRequest, {
    facetFilters,
    hitsPerPage: params.hitsPerPage ?? 10,
    page: params.page ?? 0,
  });

  const sorting = getPositiveEvSorting(context, facetFilters);
  const activeSort = resolveActiveSort(mapSearchRequest.indexName, mapSearchRequest.request.indexName, sorting.options);
  const hitRateBucket = getHitRateBucket(activeSort.field);
  const timezone = getTimezoneForRepub(context.repubConfig.name);

  const finalSearchRequest = createQueryFactory({
    activeSort,
    hitRateBucket,
    resultAttributes,
    searchRequest: mapSearchRequest,
    timezone,
  });

  return finalSearchRequest;
}
